<template>
    <div style="height: 100%;overflow: auto;">
        <van-sticky>
            <div style="background-color: white;">
            <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
            <el-form :inline="true" class="demo-form-inline" size="mini" style="margin-top: 5px;background-color: #fff;">
                <el-form-item label="门店">
                    <el-select v-model="storeid" placeholder="门店选择" @change="storeChange">
                      <el-option :label="item.brandname" :value="item.brandid" v-for="(item,key) in brands" :key="key"></el-option>
                    </el-select>
                </el-form-item>
              <el-form-item>
                <el-radio-group v-model="active" @change="activeChange">
                  <el-radio-button label="home">本月</el-radio-button>
                  <el-radio-button label="home1">上月</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
        </van-sticky>
        <el-table :data="examineData" height="calc(100% - 6.5rem)" style="width: 100%;">
            <el-table-column fixed prop="staffname" width="70" align="center" label="员工"></el-table-column>
            <el-table-column  prop="number" label="成交人数" width="100" align="center"></el-table-column>
            <el-table-column  prop="perf" label="金额" align="center">
                <template slot-scope="scope">
                    {{$parseInt(scope.row.perf)}}
                </template>
            </el-table-column>
            <el-table-column  prop="newnumber" label="新客" width="70" align="center"></el-table-column>
            <el-table-column  prop="newamount" label="新客金额" width="100" align="center"></el-table-column>
            <el-table-column  prop="bigdd" label="负责人数" align="center"></el-table-column>
            <el-table-column  prop="bigcount" label="到店人数" width="100" align="center">
                <template slot-scope="scope">
                    {{scope.row.bigcount}}({{$percentgae(scope.row.bigcount/scope.row.bigdd)}})
                </template>
            </el-table-column>
        </el-table>
        <!--<el-descriptions v-else class="margin-top" :column="2" :size="size" border>
            <el-descriptions-item label="姓名">{{examineData[0].staffname}}</el-descriptions-item>
            <el-descriptions-item label="业绩">{{examineData[0].perf}}</el-descriptions-item>
            <el-descriptions-item label="成交人数">{{examineData[0].number}}</el-descriptions-item>
            <el-descriptions-item label="新客人数">{{examineData[0].newnumber}}</el-descriptions-item>
            <el-descriptions-item label="indiba人数">{{examineData[0].indibacount}}</el-descriptions-item>
            <el-descriptions-item label="indiba到店">{{examineData[0].indibadd}}({{$percentgae(examineData[0].indibadd/examineData[0].indibacount)}})</el-descriptions-item>
            <el-descriptions-item label="大顾客人数">{{examineData[0].bigdd}}</el-descriptions-item>
            <el-descriptions-item label="大顾客次数">{{examineData[0].bigcount}}</el-descriptions-item>
        </el-descriptions>-->
    </div>
</template>
<script>
    export default {
        data() {
            return {
                examineData:[],
                brands:[],
                active:"home",
                storeid:localStorage.getItem("parentstoreid"),
                fromdate:this.$moment().startOf('month').format('YYYY-MM-DD'),
                todate:this.$moment().endOf('month').format('YYYY-MM-DD'),
                staffid:localStorage.getItem("staffid"),
            }
        },
        created() {
            this.getStoreInfoByStructsOpen();
            this.getBeautyExamine();
        },
        methods:{
            storeChange(val){
                localStorage.setItem("storeid",val);
                this.storeid=val;
                this.getBeautyExamine();
            },
            getStoreInfoByStructsOpen(){
                let parentstoreid=localStorage.getItem("parentstoreid");
                let staffid=localStorage.getItem("staffid");
                this.$post("store/getStoreByStructsByStaffId",{storeid:parentstoreid,staffid:staffid}).then(res=>{
                    if(res.sucess){
                        this.brands=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
            activeChange(name){
                //console.log(name);
                if(name=="home"){
                    this.fromdate=this.$moment().startOf('month').format('YYYY-MM-DD');
                    this.todate=this.$moment().endOf('month').format('YYYY-MM-DD');
                }
                else if(name=="home1"){
                    let dates=this.$lastMonth();
                    this.fromdate=dates[0];
                    this.todate=dates[1];
                }
                this.getBeautyExamine();
            },
            getBeautyExamine(){
                this.$post("beautymanager/getBeautyStaffExamine",{storeid:this.storeid,fromdate:this.fromdate,todate:this.todate}).then(res=>{
                    if(res.sucess){
                        this.examineData=res.object;
                    }
                    else{
                        this.$message({message: res.message,type: 'error'});
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/page/beauty/beautystaffexamine.vue